module.exports = __webpack_public_path__ + "img/list_icon1.65626420.png";